export default "__VITE_ASSET__BxmhL5RG__"